import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import _ from 'lodash';

export function PostPickerRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.PostPicker', {
		url: '/posts/pick',
		controllerAs: 'vm',
		controller: PostPickerCtrl,
		templateUrl: '/ng/hub/Post/Picker/PostPickerCtrl.html?' + window.BUILD,
		resolve: {
			$style: () => AssetManager.css('/ng/hub/Post/Picker/PostPickerCtrl.css'),
			$title: () => 'Choose Posts',
		},
	});
}

export class PostPickerCtrl {
	constructor(modal, Post, FineTunePosts) {
		'ngInject';
		// save injections
		this.modal = modal;
		this.Post = Post;
		this.FineTunePosts = FineTunePosts;
		this.clearSkippedList = this.clearSkippedList.bind(this);
	}

	$onInit() {
		this.alreadyPicked = this.extractPickedFromUrl();
		this.FineTunePosts.avoidStoryResults = true;
		this.posts = [];
		this.search = {
			notIds: [...this.alreadyPicked],
		};
		this.skippedPosts = [];
		this.fineTunerClosed = true;

		// if true, this makes it so the fine tuner will only return posts that have emailing as an allowed action
		this.isOnEmailScreen = window.parent && window.parent.location.href.includes('email_publish');
	}

	extractPickedFromUrl() {
		const match = window.location.href.match(/picked=([\d,]+)/);
		if (!match) {
			return [];
		}
		const ids = match[1]
			.split(',')
			.map(parseFloat)
			.filter(n => n > 0);
		return ids;
	}

	loadMore() {
		const theseIds = _.map(this.posts, 'id');
		this.skippedPosts.push(...theseIds);
		const notIds = [...this.alreadyPicked, ...this.skippedPosts];
		this.posts = [];
		this.status = 'loading';
		const newCriteria = { ...this.FineTunePosts.search, notIds };
		this.FineTunePosts.fetch(newCriteria, { excludeRestrictedFromShareViaEmailBrief: this.isOnEmailScreen }).then(
			posts => {
				this.status = 'loaded';
				this.posts = posts;
			}
		);
	}

	clearSkippedList() {
		this.skippedPosts.length = 0;
	}

	pick(post) {
		post.isHidden = true;
		this.alreadyPicked.push(post.id);
		try {
			// if another domain (e.g. localhost:3000) accessing a property on window.parent with throw Error
			// if the addSearchPost function is not defined, it will also throw an Error
			window.parent.addSearchPost(post.id);
		} catch (e) {}
		try {
			const message = JSON.stringify({
				action: 'postPicked',
				post,
			});
			// will fail if window.parent is undefined
			window.parent.postMessage(message, '*');
		} catch (e) {}
	}

	viewFullscreen(post) {
		this.Post.viewFullscreen(post);
	}
}
